import {GoftinoSnippet} from '@mohsen007/react-goftino';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import {Box, Grid} from '@mui/material';
import Badge from '@mui/material/Badge';
import CircularProgress from '@mui/material/CircularProgress';
import {useEffect, useState} from 'react';
import {useMutation, useQuery, useQueryClient} from 'react-query';
import {useDispatch, useSelector} from 'react-redux';
import HomeMenuCard from '../../../components/card/homeMenuCard/HomeMenuCard';
import InProcessLoansCardSkeleton from '../../../components/card/loanCard/InProcessLoansCardSkeleton';
import InProgressLoans from '../../../components/card/loanCard/InProgressLoans';
import CheckIcon from '../../../components/icons/CheckIcon';
import CreditIcon from '../../../components/icons/CreditIcon';
import FileIcon from '../../../components/icons/FileIcon';
import HistoryIcon from '../../../components/icons/HistoryIcon';
import HugeIconGold from '../../../components/icons/HugeIconGold';
import KamanSymbol from '../../../components/icons/KamanSymbol';
import OnllineSupportIcon from '../../../components/icons/OnllineSupportIcon';
import PersonIcon from '../../../components/icons/PersonIcon';
import RequestIcon from '../../../components/icons/RequestIcon';
import ShopIcon from '../../../components/icons/ShopIcon';
import {SmartImage} from '../../../components/images/SmartImage';
import {useAuth} from '../../../config/AuthProvider/authProvider';
import {
    ADTRACE_EVENT_TOKEN_STORE,
    ADTRACE_EVENT_TOKEN_SUBMIT_LOAN_REQUEST,
    DOCUMENT_TYPES,
    LOANS_INFO,
    REPAYMENT_TYPE,
    SALE_ID,
} from '../../../config/cacheKey';
import {useAdtraceEvent} from '../../../hooks/useAdtraceEvent';
import {IBannersResponse} from '../../../models/banner.model';
import {IDocumentTypeHints} from '../../../models/basicInformation.model';
import {IGetCustomerInfoResponse} from '../../../models/customer.model';
import {GetSummaryOfInProgressLoansResponse} from '../../../models/loan.model';
import {IGetLoansResponse} from '../../../models/registration.model';
import {
    getNextInnerState,
    getNextState,
} from '../../../redux/handleBackBtn/handleBackBtnSlice';
import {setHeaderTitle} from '../../../redux/headerTitle/headerTitleSlice';
import {getpervStateTab} from '../../../redux/loansTab/loansTabSlice';
import {RootState} from '../../../redux/store';
import {SetGoftinoUser} from '../../../services/account.service';
import {GetBanners} from '../../../services/banner.service';
import {GetDocumentTypes} from '../../../services/basicInformation.service';
import {
    GetLoans,
    GetSummaryOfInProgressLoans,
    GetSummaryOfOnlinePaymentLoans,
} from '../../../services/loan.service';
import {getNoticeCount} from '../../../services/notification.service';
import hideElement from '../../../utility/hideElement';
import showElement from '../../../utility/showElement';
import CustomModal from './customeModal';
import './homeMenu.css';
import {IInnerStateHomeMenu} from './IHomeMenu';

declare global {
    interface Window {
        Goftino: any;
    }
}

const HomeMenu = ({
    setTabChild,
    setState,
    totalBalance,
    waitingPurchases,
}: IInnerStateHomeMenu) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [countNotification, setCountNotification] = useState<number>(0);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [banners, setBanners] = useState<IBannersResponse[]>();
    const [isModalOpen, setModalOpen] = useState(false);
    const [inProgressLoans, setInProgressLoans] = useState<
        GetSummaryOfInProgressLoansResponse[]
    >([]);
    const [onlinePaymentLoans, setOnlinePaymentLoans] = useState<
        GetSummaryOfInProgressLoansResponse[]
    >([]);
    const mode = useSelector((state: RootState) => state.theme) as
        | 'light'
        | 'dark';
    const {trackEvent} = useAdtraceEvent();
    const queryClient = useQueryClient();
    const {setRefKey} = useAuth();
    const {
        profile,
        isLoading,
    }: {profile: IGetCustomerInfoResponse; isLoading: boolean} =
        queryClient?.getQueryData('PROFILE_INFO')! || {};

    const {mutate: BannersMutate} = useMutation(GetBanners, {
        onSuccess: (data: IBannersResponse[]) => {
            if (data) {
                setBanners(data);
            }
        },

        onError: () => {},
    });

    const {data: loansData, refetch} = useQuery(['loans'], GetLoans, {
        onSuccess: (data: IGetLoansResponse[]) => {
            const assignedLoan = data.find(
                (item) => item.loanRequestStatus === 'Assigned'
            );

            if (!assignedLoan) return;

            queryClient.setQueryData(LOANS_INFO, assignedLoan);
            queryClient.setQueryData(
                REPAYMENT_TYPE,
                assignedLoan.repaymentType
            );

            localStorage.setItem('LOANS_INFO', JSON.stringify(assignedLoan));
        },
    });
    const openModal = () => {
        setModalOpen(true);
    };
    const closeModal = () => {
        setModalOpen(false);
    };
    const randomKeyForDispatch = Math.random();
    const handleClick = () => {
        setTabChild!(2);
        dispatch(getpervStateTab({prevState: 'loans'}));
    };

    const moveToStores = () => {
        trackEvent(ADTRACE_EVENT_TOKEN_STORE);
        setTabChild!(1);
    };

    const moveToNewRequest = () => {
        trackEvent(ADTRACE_EVENT_TOKEN_SUBMIT_LOAN_REQUEST);
        setTabChild!(2);
        setRefKey(null);
        dispatch(getpervStateTab({prevState: 'appContainer'}));
        dispatch(getNextState({nextState: `selectLoanTemplate`}));
        queryClient.setQueryData('LOAN_TEMPLATE_KEY', '');
    };
    const moveToOnlinePaymentLoans = () => {
        trackEvent(ADTRACE_EVENT_TOKEN_SUBMIT_LOAN_REQUEST);
        setTabChild!(2);
        if (onlinePaymentLoans?.length > 1) {
            // setRefKey(null);
            dispatch(getpervStateTab({prevState: 'loans'}));
        } else {
            //move to installment
            setRefKey(onlinePaymentLoans![0].referenceKey);
            refetch();
            dispatch(getpervStateTab({prevState: 'installment'}));
            dispatch(getNextInnerState({nextInnerState: `AssignedLoans`}));
        }
    };
    const handleBannerClick = (actionUrl: string) => {
        if (actionUrl && actionUrl?.includes('internalState')) {
            const state = actionUrl?.split(':')[1] as any;
            if (state === 'newLoanRequest') {
                moveToNewRequest();
                return;
            }
            setState!(state);
            setRefKey(null);
        } else {
            window.open(actionUrl);
        }
    };

    useEffect(() => {
        dispatch(
            setHeaderTitle({color: 'var(--input-bg-color)', display: 'none'})
        );
        GetNoticeCountMutate();
        documentTypeMutation();
        GetSummaryOfInProgressLoansMutate();
        GetSummaryOfOnlinePaymentLoansMutate();
        BannersMutate();
    }, []);

    const handleWllet = () => {
        setTabChild!(1);
        dispatch(getpervStateTab({prevState: 'wallet'}));
    };
    const {mutate: GetNoticeCountMutate} = useMutation(getNoticeCount, {
        onSuccess: (data: number) => {
            setCountNotification(data);
            setModalOpen(true);
        },
    });

    setTimeout(() => setLoading(false), 2000);

    const {mutate: SetGoftinoUserMutate} = useMutation(SetGoftinoUser, {
        onSuccess: (data: boolean) => {
            if (data) {
            }
        },
        onError: () => {},
    });
    const {
        mutate: GetSummaryOfInProgressLoansMutate,
        isLoading: inProcessLoansLoading,
    } = useMutation(GetSummaryOfInProgressLoans, {
        onSuccess: (data: GetSummaryOfInProgressLoansResponse[]) => {
            if (data) {
                setInProgressLoans(data);
            }
        },
        onError: () => {},
    });

    const {mutate: GetSummaryOfOnlinePaymentLoansMutate} = useMutation(
        GetSummaryOfOnlinePaymentLoans,
        {
            onSuccess: (data: GetSummaryOfInProgressLoansResponse[]) => {
                if (data) {
                    setOnlinePaymentLoans(data);
                }
            },
            onError: () => {},
        }
    );

    const {mutateAsync: documentTypeMutation} = useMutation(GetDocumentTypes, {
        onSuccess: (data: IDocumentTypeHints[]) => {
            localStorage.setItem(DOCUMENT_TYPES, JSON.stringify(data));
        },
    });

    const goToOngoingPurchases = () => {
        if (waitingPurchases && waitingPurchases.length > 0) {
            if (waitingPurchases.length == 1) {
                queryClient.setQueryData(SALE_ID, waitingPurchases[0].saleKey);
                setState!('ongoingDetailPurchase');
            } else {
                setState!('ongoingPurchases');
            }
        }
    };
    const handleMoveToPurchaceGold = () => {
        setState!('trade');
        setRefKey(null);
    };

    const handleInProgressLoans = (
        referenceKey: string,
        loanTemplateKey: string
    ) => {
        sessionStorage.setItem(
            'HAS_INPROGRESS',
            JSON.stringify({inProgress: true})
        );
        queryClient.setQueryData('LOAN_TEMPLATE_KEY', loanTemplateKey);
        setRefKey(referenceKey);
        setTabChild!(2);
        dispatch(getpervStateTab({prevState: 'appContainer'}));
    };

    const moveToMenu = () => {
        setTabChild!(3);
    };
    useEffect(() => {
        hideElement('fixed-bottom-navigation');
        return () => {
            showElement('fixed-bottom-navigation');
        };
    }, []);
    const cards = [
        {
            id: 1,
            title: 'تسهیلات من',
            icon: <FileIcon className="text-[var(--primary-text-color)]" />,
            onClick: () => handleClick(),
        },
        {
            id: 2,
            title: 'پرداخت معوقات',
            icon: <CreditIcon className="text-[var(--primary-text-color)]" />,
            onClick: () => setState!('newPayment'),
        },
        {
            id: 3,
            title: 'سوابق خرید',
            icon: <HistoryIcon className="text-[var(--primary-text-color)]" />,
            onClick: () => setState!('purchaseRecords'),
        },
        {
            id: 4,
            title: 'بازار',
            icon: <ShopIcon className="text-[var(--primary-text-color)]" />,
            onClick: () => moveToStores(),
        },
        {
            id: 5,
            title: 'خرید طلای دیجیتال',
            icon: <HugeIconGold className="text-[var(--primary-text-color)]" />,
            onClick: () => handleMoveToPurchaceGold(),
        },
        {
            id: 6,
            title: 'ضامن شده اید',
            icon: <CheckIcon className="text-[var(--primary-text-color)]" />,
            onClick: () => setState!('garantour'),
        },
        {
            id: 7,
            title: 'پشتیبانی آنلاین',
            icon: (
                <OnllineSupportIcon className="text-[var(--primary-text-color)]" />
            ),
            onClick: () => window.Goftino.open(),
        },
    ];

    return (
        <Grid
            container
            flexWrap={'nowrap'}
            flexDirection={'column'}
            height={'100svh'}
            style={{padding: '0 !important', overflowY: 'auto'}}
        >
            {/* top section */}
            <Box
                sx={{position: 'relative', width: '50%', objectFit: 'contain'}}
            >
                <KamanSymbol
                    className="text-[var(--icon-color)] absolute  top-0 right-0 
                h-[220px] w-[165px]  mr-0
                mt-[-70px] 
                "
                />
            </Box>
            <Grid item sx={{height: 'fit-content'}}>
                <Box sx={{paddingInline: '20px', marginTop: '10px'}}>
                    <Grid
                        container
                        flexDirection={'column'}
                        sx={{
                            zIndex: 2000,
                            background: 'transparent',
                            color: '#FFF',
                            position: 'sticky',
                            top: '0px',
                            '@media (min-width: 550px)': {
                                borderRadius: '7px',
                                margin: 'auto',
                                width: '100%',
                            },
                        }}
                    >
                        <Grid
                            width={'100%'}
                            xs={12}
                            sx={{
                                zIndex: '3000',
                                textAlign: 'start',
                                display: 'flex',
                                flexDirection: 'row-reverse',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <div className="flex items-center gap-2">
                                <div>
                                    <div
                                        style={{
                                            fontSize: '.65rem',
                                            color: 'var(--primary-text-color)',
                                        }}
                                        onClick={handleWllet}
                                    >
                                        مجموع اعتبار شما به ریال
                                    </div>
                                    {totalBalance! >= 0 ? (
                                        <div
                                            style={{
                                                fontSize: '1.1rem',
                                                color: 'var(--primary-text-color)',
                                            }}
                                            onClick={handleWllet}
                                        >
                                            <b className="text-[var(--primary-text-color)]">
                                                {totalBalance?.toLocaleString()}{' '}
                                                &nbsp;
                                            </b>
                                        </div>
                                    ) : (
                                        <CircularProgress
                                            sx={{color: '#BBA57A'}}
                                            size={20}
                                        />
                                    )}
                                </div>
                                <div className="text-[var(--hr-color)]">|</div>
                                <div
                                    className="cursor-pointer"
                                    onClick={moveToMenu}
                                >
                                    <PersonIcon className="text-[var(--primary-text-color)]" />
                                </div>
                            </div>
                            <Grid
                                sx={{
                                    zIndex: '3000',
                                    textAlign: 'end',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'left',
                                    background: 'var(--bg-color)',
                                    width: 'fit-content',
                                    height: 'fit-content',
                                    borderRadius: '50%',
                                }}
                            >
                                <Badge
                                    onClick={
                                        countNotification > 0
                                            ? openModal
                                            : () => setState!('notifications')
                                    }
                                    badgeContent={''}
                                    color="error"
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    overlap="circular"
                                    sx={{
                                        '& .MuiBadge-badge': {
                                            width: '8px',
                                            height: '8px',
                                            minWidth: '8px',
                                            padding: 0.5,
                                            borderRadius: '50%',
                                            display: 'none',
                                        },
                                    }}
                                >
                                    {' '}
                                    {countNotification > 0 ? (
                                        <FiberManualRecordIcon
                                            style={{
                                                width: '12px',
                                                height: '12px',
                                                marginTop: '13px',
                                                marginLeft: '-12px',
                                                zIndex: '10000',
                                            }}
                                        />
                                    ) : null}
                                    <NotificationsOutlinedIcon
                                        sx={{
                                            color: 'var(--primary-text-color)',
                                        }}
                                        className="iconHome"
                                    />
                                </Badge>
                                {countNotification > 0 ? (
                                    <CustomModal
                                        isOpen={isModalOpen}
                                        onClose={closeModal}
                                        position={{top: '7.5svh', left: '7px'}}
                                        countNotification={countNotification}
                                        setState={setState}
                                    />
                                ) : (
                                    false
                                )}
                            </Grid>
                        </Grid>
                        <Grid width={'100%'} xs={12}>
                            <Grid
                                container
                                columnSpacing={2}
                                sx={{marginTop: '1.2rem'}}
                            >
                                <Grid
                                    item
                                    xs={onlinePaymentLoans?.length > 0 ? 6 : 12}
                                >
                                    <div
                                        onClick={moveToNewRequest}
                                        className="cursor-pointer flex items-center gap-2 text-[0.875rem] bg-[var(--bg-color)] rounded-[12px]"
                                        style={{
                                            color: 'var(--primary-text-color)',
                                            padding: '.9rem',
                                            border:
                                                mode === 'light'
                                                    ? '1px solid rgb(220,220,220)'
                                                    : '1px solid rgb(53,53,53)',
                                        }}
                                    >
                                        <RequestIcon className="text-[var(--primary-text-color)] " />{' '}
                                        درخواست تسهیلات
                                    </div>
                                </Grid>

                                {onlinePaymentLoans?.length > 0 && (
                                    <Grid item xs={6}>
                                        <div
                                            onClick={moveToOnlinePaymentLoans}
                                            className="cursor-pointer flex items-center text-[0.875rem] gap-2 bg-[var(--bg-color)] rounded-[12px]"
                                            style={{
                                                color: 'var(--primary-text-color)',
                                                padding: '.9rem',
                                                border:
                                                    mode === 'light'
                                                        ? '1px solid rgb(220,220,220)'
                                                        : '1px solid rgb(53,53,53)',
                                            }}
                                        >
                                            <FileIcon className="text-[var(--primary-text-color)] " />{' '}
                                            پرداخت اقساط
                                        </div>
                                    </Grid>
                                )}
                            </Grid>

                            {/* links cards */}
                            <Box sx={{marginTop: '10px', width: '100%'}}>
                                <Grid
                                    container
                                    xs={12}
                                    sx={{
                                        boxShadow: 'none',
                                        border:
                                            mode === 'light'
                                                ? '1px solid rgb(220,220,220)'
                                                : '1px solid rgb(53,53,53)',
                                    }}
                                    className=" bg-[var(--bg-color)] rounded-[12px]"
                                >
                                    {cards.map((card, index) => (
                                        <Grid key={index} xs={3}>
                                            <HomeMenuCard
                                                onClick={card.onClick}
                                                title={card.title}
                                                icon={card.icon}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
            <Grid
                item
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'column',
                    height: 'fit-content',
                }}
            >
                <Box>
                    <div>
                        {/* waiting purchases */}
                        {waitingPurchases && waitingPurchases.length > 0 && (
                            <Grid
                                container
                                style={{
                                    marginTop: '12px',
                                    marginBottom: '1px',
                                    paddingInline: '20px',
                                }}
                            >
                                <Grid
                                    container
                                    xs={12}
                                    style={{
                                        background: 'var(--input-bg-color)',
                                        minHeight: '60px',
                                        alignContent: 'center',
                                        textAlign: 'center',
                                        justifyContent: 'space-between',
                                        borderRadius: '8px',
                                        padding: '10px 20px',
                                        border: '1px solid var(--border-color)',
                                    }}
                                    onClick={() => goToOngoingPurchases()}
                                >
                                    <Grid
                                        item
                                        xs={8}
                                        md={9}
                                        sm={10}
                                        style={{
                                            textAlign: 'justify',
                                            paddingRight: '0.4vh',
                                            alignContent: 'center',
                                            fontSize: '12.5px',
                                            paddingLeft: '10px',
                                        }}
                                        className="anjomanRegular"
                                    >
                                        <span
                                            className="text-[var(--primary-text-color)]"
                                            style={{fontSize: '1rem'}}
                                        >
                                            <span
                                                className="text-[var(--primary-text-color)]"
                                                style={{
                                                    fontSize: '1.1rem',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                {waitingPurchases.length}
                                            </span>{' '}
                                            خرید در جریان
                                        </span>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={4}
                                        md={3}
                                        sm={2}
                                        textAlign={'end'}
                                    >
                                        <ChevronLeftOutlinedIcon
                                            sx={{
                                                fontSize: '1.5rem',
                                                marginRight: '10px',
                                                color: 'gray',
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                        {/* inprogress loans */}
                        {!inProcessLoansLoading ? (
                            inProgressLoans?.length > 0 && (
                                <Box
                                    sx={{
                                        marginTop: '20px',
                                        marginBottom: '1px',
                                        paddingInline: '20px',
                                    }}
                                >
                                    <InProgressLoans
                                        inProgressLoans={inProgressLoans}
                                        handleInProgressLoans={
                                            handleInProgressLoans
                                        }
                                    />
                                </Box>
                            )
                        ) : (
                            <InProcessLoansCardSkeleton />
                        )}

                        {/* new request */}
                        <Grid
                            container
                            sx={{
                                paddingBottom: '20px',
                                width: '100%',
                                flexDirection: 'column',
                                marginTop: '20px',
                                gap: 2,
                            }}
                        >
                            {banners?.map((banner) => (
                                <Grid
                                    item
                                    key={banner.imageUrl}
                                    sx={{
                                        borderRadius: '8px',
                                        marginInline: '20px',
                                        objectFit: 'cover',
                                        overflow: 'hidden',
                                    }}
                                    onClick={() =>
                                        handleBannerClick(banner.actionUrl)
                                    }
                                >
                                    <SmartImage
                                        src={banner.imageUrl}
                                        alt="image"
                                        imageStyle={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            display: 'block',
                                            borderRadius: '8px',
                                        }}
                                        size={'100%'}
                                        borderRadius={8}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                </Box>
                {profile?.nationalCode && (
                    <GoftinoSnippet
                        goftinoKey={'qzVes1'}
                        onReady={() => {
                            window.Goftino.getUserId();
                            window.Goftino.setUser({
                                name: profile?.fullName,
                                phone: profile?.mobileNumber,
                            });
                            window.Goftino.setWidget({
                                hasIcon: false,
                            });
                            if (!profile?.goftinoUserId) {
                                SetGoftinoUserMutate({
                                    goftinoUserId: window.Goftino.getUserId(),
                                });
                            } else {
                                window.Goftino.setUserId(
                                    profile?.goftinoUserId
                                );
                            }
                        }}
                    />
                )}
            </Grid>
        </Grid>
    );
};

export default HomeMenu;
